import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders,HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageService } from '../../service/managers/storage.service';

import { MergeTemplate } from '../../model/merge-template'
import { Config } from '../component_dependent/config';


@Injectable({
  providedIn: 'root'
})
export class MergeTemplateService extends Config {

  constructor(private http: HttpClient, private storageService: StorageService) {
    super();
  }

  public getTemplate(maxItemsPerPage,page,keyword){

    const params = new HttpParams()
    .set('keyword',keyword)
    .set('page',page)
    .set('maxItemsPerPage',maxItemsPerPage)
    
    var url = "get_templates";
    const head = this.storageService.getHead()
    const options = {params: params,headers:head}

    return this.http.get(this.BASE_URL + url,options);
  }

  public saveTemplate(temp:MergeTemplate){
      var url ="save_template";
      let  newTemp 
      if(temp.id != ''){
         newTemp = {
          id:temp.id,
          template:temp.template
       }
      }else{
          newTemp = {
          template:temp.template
       }
      }

      
      return this.http.post(this.BASE_URL + url, newTemp ,this.storageService.getHeaders())
  }
  
  // public getCallType(){
  //   var url = "get_call_type"
  //   return this.httpClient.get(this.BASE_URL + url,this.storageService.getHeaders())
  // }
  
  // public getBatchType(){
  //   var url = "get_batch_type"
  //   return this.httpClient.get(this.BASE_URL + url,this.storageService.getHeaders())
  // }


}
